import _ from "../../../../@lodash";

const TemplateModel = (data) =>
  _.defaults(data || {}, {
    title: "",
    label: "",
    classification: "",
    description: "",
    instructions: [
      { 
        title: '', 
        label: '', 
        course: 'Default',
        rtl: false,
        content: '',
      }
    ],
    image: "",
    branching: "",
    dev_notes: "",
    ga_notes: "",
    accessibility: "",
    access_table: [
      { 
        element: "", 
        items: [
          { 
            compliance: "",
            notes: ""
          }
        ]
      }
    ],
    info: "",
    components: [
      {
        image: "",
        component: "",
        elements: [
          { 
            title: "",
            attrs: [
              {
                property: "",
                value: ""
              }
            ]
          }
        ]
      }
    ],
    content: {},
  });

export default TemplateModel;
